export default {"src":"/_next/static/media/share-icon-secondary.b800b826.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};